import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import styled, { css } from 'styled-components'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import WarrantyBadge, { WarrantyBadgeTitle } from 'components/common/WarrantyBadge'
import TireRating from 'components/OneColumnSearchResultPage/components/TireRating'
import {
  Block,
  CellLeft,
  CellRight,
  Tire,
  Logo,
  TireLineName
} from 'components/OneColumnSearchResultPage/components/ProductBlock/styles'
import ProductPromotionsAndSpecs from 'components/OneColumnSearchResultPage/components/ProductPromotionsAndSpecs'
import PromotionTeaser from '../../components/PromotionTeaser'
import { arrayHasValues, isInventoryStatusLoaded } from 'helpers/utils'
import FavoriteButton from './../../../MyFavorites/FavoriteButton'
import ProductFlag from 'components/common/ProductFlag/ProductFlag'
import {
  OE_TOOLTIP_MESSAGE,
  OE_FLAG_TYPE,
  OE_FLAG_NAME,
  EVS_FLAG_TYPE,
  EVS_FLAG_NAME,
  EVS_TOOLTIP_MESSAGE,
  EVS_FLAG_ICON_NAME,
  EVC_FLAG_TYPE,
  EVC_FLAG_NAME,
  EVC_TOOLTIP_MESSAGE,
  EVC_FLAG_ICON_NAME
} from 'components/common/ProductFlag/constans'
import TireAvailability from 'components/common/TireAvailability'
import { ADDING_TO_SHOPPING_QUOTE, INVENTORY_STATUS_LOADED } from 'components/common/UpdatingBlock/constants'
import useSERPTiresAvailabilityStatus from 'src/hooks/useSERPTiresAvailabilityStatus.js'
import UpdatingBlock from 'components/common/UpdatingBlock'
import CompatibilityLabel from 'components/common/CompatibilityLabel'

const ProductHeader = ({
  storeNumber,
  brandName,
  bvId,
  inventoryStatuses,
  isHorizontal,
  isPilotStore,
  reviewsLink,
  tireDetailUrl,
  sizeFront,
  sizeRear,
  srcTire,
  srcLogo,
  skuId,
  title,
  countFront,
  countRear,
  specifications,
  promotions = [],
  promotionsPreviewItems = [],
  promotionsRestItems = [],
  handleProductClick = () => {},
  warrantyBadges: [{
    name: warrantyName,
    value: warrantyValue
  } = {}] = [],
  isOeItem,
  isEvItem,
  itemEVType,
  availability = {},
  compatibilityState,
  vehicleName
}) => {
  /* this custom hook is designed to make inventory service call when quantity is updated on the SERP */
  const [availabilityForQtyChange] = useSERPTiresAvailabilityStatus({
    countFront,
    brandName,
    frontTireBvId: bvId,
    storeNumber,
    dependencies: [countFront, isPilotStore],
    productSkuId: skuId,
    isPilotStore
  })
  const renderTireAvailability = (
    <AvailabilityWrapper
      name={ INVENTORY_STATUS_LOADED }
      value={ skuId }
      condition={ isInventoryStatusLoaded(inventoryStatuses, skuId) }>
      <TireAvailability availability={ !isEmpty(availabilityForQtyChange) ? availabilityForQtyChange : availability } />
    </AvailabilityWrapper>
  )

  return <React.Fragment>
    <UpdatingBlock
      name={ ADDING_TO_SHOPPING_QUOTE }
      value={ skuId } >
      <Block>
        <CellLeft>
          <Link to={ tireDetailUrl } onClick={ handleProductClick }>
            <Tire
              data-at-serp-tire-img
              src={ `${srcTire}?$BOT-TireSearchResult-Tire-Desktop-w180$` }
              alt="Navigate to product details page" />
          </Link>
        </CellLeft>
        <CellRight>
          <CellRightBlock isHorizontal={ isHorizontal }>
            <div>
              <TireTitleLink data-at-serp-tire-title block to={ tireDetailUrl } onClick={ handleProductClick }>
                {
                  srcLogo &&
                  <div>
                    <BrandLogo
                      data-at-serp-tire-brandlogo
                      src={ `${srcLogo}?$BOT-Tire-Search-Result-Brand-Desktop-h30$` }
                      alt="" />
                  </div>
                }
                <TireLineTitle>
                  { title }
                </TireLineTitle>
              </TireTitleLink>
              <SizeTitle>
                <Size data-at-front-size>
                  { sizeRear && <TitleTire>Front</TitleTire> }
                  { sizeFront }
                </Size>
                { sizeRear &&
                <Size data-at-rear-size>
                  <TitleTire>Rear</TitleTire>
                  { sizeRear }
                </Size>
                }
                { (isOeItem || isEvItem) &&
                <ProductFlagWrapper>
                  { isOeItem &&
                    <ProductFlag
                      flagType={ OE_FLAG_TYPE }
                      name={ OE_FLAG_NAME }
                      tooltipMessage={ OE_TOOLTIP_MESSAGE }
                      gbb />
                  }
                  { (isEvItem && itemEVType === EVS_FLAG_TYPE) &&
                    <ProductFlag
                      flagType={ EVS_FLAG_ICON_NAME }
                      tooltipMessage={ EVS_TOOLTIP_MESSAGE }
                      name={ EVS_FLAG_NAME }
                      gbb />
                  }
                  { (isEvItem && itemEVType === EVC_FLAG_TYPE) &&
                    <ProductFlag
                      flagType={ EVC_FLAG_ICON_NAME }
                      tooltipMessage={ EVC_TOOLTIP_MESSAGE }
                      name={ EVC_FLAG_NAME }
                      gbb />
                  }
                </ProductFlagWrapper>
                }
              </SizeTitle>
              <CustomTireRating
                bvId={ bvId }
                reviewName={ title }
                reviewsLink={ reviewsLink }
                small
                isHorizontal={ isHorizontal } />
              {
                Boolean(compatibilityState) &&
                <CompatibilityWrapper>
                  <CompatibilityLabel dense status={ compatibilityState } vehicle={ vehicleName } />
                </CompatibilityWrapper>
              }
            </div>
            <WarrantyBlock isHorizontal={ isHorizontal }>
              <IconWrapper>
                <WarrantyBadge name={ warrantyName } warranty={ warrantyValue } />
              </IconWrapper>
              <WarrantyBadgeTitle name={ warrantyName } value={ warrantyValue } />
            </WarrantyBlock>
            {
              isHorizontal && arrayHasValues(promotions) && <PromotionBlock>
                <PromotionTeaser promotions={ promotions } />
              </PromotionBlock>
            }

            <FavoriteButtonHeart
              countFront={ countFront }
              countRear={ countRear }
              skuId={ skuId }
              tireLineName={ title }
              imageUrl={ srcTire }
              brandLogoUrl={ srcLogo }
              frontTireSize={ sizeFront }
              rearTireSize={ sizeRear } />
          </CellRightBlock>
        </CellRight>
      </Block>
    </UpdatingBlock>
    {
      isHorizontal ?
        <ProductPromotionsAndSpecs
          frontTire={{ specification: specifications }} /> :
        <ProductPromotionsAndSpecs
          promotions={ promotions }
          promotionsPreviewItems={ promotionsPreviewItems }
          promotionsRestItems={ promotionsRestItems }
          frontTire={{
            specification: specifications
          }} />
    }
    {renderTireAvailability}
  </React.Fragment>
}

ProductHeader.propTypes = {
  availability: PropTypes.shape(),
  brandName: PropTypes.string,
  bvId: PropTypes.string,
  compatibilityState: PropTypes.string,
  countFront: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  countRear: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  handleProductClick: PropTypes.func,
  inventoryStatuses: PropTypes.arrayOf(PropTypes.shape()),
  isEvItem: PropTypes.bool,
  isHorizontal: PropTypes.bool,
  isOeItem: PropTypes.bool,
  isPilotStore: PropTypes.bool,
  itemEVType: PropTypes.string,
  promotions: PropTypes.arrayOf(PropTypes.shape()),
  promotionsPreviewItems: PropTypes.arrayOf(PropTypes.shape()),
  promotionsRestItems: PropTypes.arrayOf(PropTypes.shape()),
  reviewsLink: PropTypes.string,
  sizeFront: PropTypes.string,
  sizeRear: PropTypes.string,
  skuId: PropTypes.string,
  specifications: PropTypes.arrayOf(PropTypes.shape()),
  srcLogo: PropTypes.string,
  srcTire: PropTypes.string,
  storeNumber: PropTypes.string,
  tireDetailUrl: PropTypes.string,
  title: PropTypes.string,
  vehicleName: PropTypes.string,
  warrantyBadges: PropTypes.arrayOf(PropTypes.shape())
}

export default ProductHeader

const TireLineTitle = styled(TireLineName)`
  font-size: 16px;
  font-weight: 600;
  margin: 10px 0;
  min-height: auto;
`

const TitleTire = styled.div`
  text-transform: uppercase;
  line-height: 12px;
  ${Mixin.font.GothamBold(10)}
`

const SizeTitle = styled.div`
  display: flex;
  align-items: center;
`

const CellRightBlock = styled.div`
  position: relative;
  padding-top: 15px;
  ${props => props.isHorizontal && css`
    display: flex;
    flex-direction: row;
    padding: 20px 40px;
  `}
`

const TireTitleLink = styled(Link)`
  width: fit-content;
`

const FavoriteButtonHeart = styled(FavoriteButton)`
  position: absolute;
  top: -30px;
  right: -10px;
`

const Size = styled.div`
  line-height: normal;
  text-transform: uppercase;
  margin-right: 10px;
  color: ${Theme.colors.black_new};
  ${Mixin.font.GothamBold(14)}
  ${Media.mobile`
    display: inline-block;
  `}
  ${props => props.inline && css`
    display: inline;
  `}
`

const WarrantyBlock = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 5px 10px 15px 15px;
  margin-top: 15px;
  ${props => props.isHorizontal && css`
    padding: 5px 10px 15px 35px;
    margin-top: 10px;
    border-left: 1px solid ${Theme.colors.light_grey};
    margin-left: 25px;
  `}
`

const PromotionBlock = styled.div`
  border-left: 1px solid ${Theme.colors.light_grey};
  margin-left: 25px;
  padding-left: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const IconWrapper = styled.div`
  display: inline-block;
  min-height: 55px;
  text-align: center;
  margin-right: 10px;
`

const BrandLogo = styled(Logo)`
  max-width: 140px;
`

const CustomTireRating = styled(TireRating)`
  margin-top: 10px;
  ${props => !props.isHorizontal && css`
    display: block;

    & a, span {
      margin: 0;
    }
  `}
`

const ProductFlagWrapper = styled.div`
  display: flex;
  align-items: center;

  & > span:first-of-type {
    margin-left: 0;
  }
`
const AvailabilityWrapper = styled(UpdatingBlock)`
  margin-bottom: 20px;
`

const CompatibilityWrapper = styled.div`
  padding: 15px 0 0;
`
